import { DAYLIGHT_MODE_TRANSITION_MS } from "@shared/daylightMode";

/** Matches CSS --daylight-transition-duration when motion is allowed. */
export function daylightModeTransitionMs(): number {
  if (typeof window === "undefined") return DAYLIGHT_MODE_TRANSITION_MS;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return 0;
  return DAYLIGHT_MODE_TRANSITION_MS;
}
